import {
  IOnboardingSetupRequest,
  IOnboardingProposal,
  IApplyOnboardingSetup,
  IExtractedService,
} from '@torim-app/types';
import { adminUrlBuilder } from '@app/api/utils';

export class OnboardingApi {
  /** Extract the business's services from uploaded images / PDFs using AI. */
  static async extractServices(body: FormData): Promise<IExtractedService[]> {
    const url = adminUrlBuilder({}, 'ai/extract-services');
    const response = await fetch(url, {
      method: 'post',
      body,
    });

    if (!response.ok) throw new Error('Failed to extract services from files');
    const data = await response.json();
    return data.services ?? [];
  }

  static async generateSetup(data: IOnboardingSetupRequest): Promise<IOnboardingProposal> {
    const url = adminUrlBuilder({}, 'ai/onboarding-setup');
    const response = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (!response.ok) throw new Error('Failed to generate onboarding setup');
    return response.json();
  }

  static async chat(
    message: string,
    currentProposal: IOnboardingProposal,
    conversationHistory: Array<{ role: 'user' | 'assistant'; content: string }>,
  ): Promise<{ reply: string; updatedProposal?: IOnboardingProposal }> {
    const url = adminUrlBuilder({}, 'ai/onboarding-chat');
    const response = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ message, currentProposal, conversationHistory }),
    });

    if (!response.ok) throw new Error('Failed to send onboarding chat message');
    return response.json();
  }

  static async applySetup(data: IApplyOnboardingSetup): Promise<{ success: boolean; bid: string }> {
    const url = adminUrlBuilder({}, 'ai/apply-onboarding');
    const response = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (!response.ok) throw new Error('Failed to apply onboarding setup');
    return response.json();
  }
}
